import { useLazyQuery } from "@apollo/client";
import { Icon, IconButton, Tooltip } from "@chakra-ui/react";
import { useState } from "react";
import { BsDownload } from "react-icons/bs";
import { useHitlFilters } from "..";
import { ReviewedUrlType, ReviewedUrlTypeEdge } from "../../../graphql/generated";
import { GET_REVIEWED_URLS_LIST_PAGINATION_DOWNLOAD } from "../../../graphql/operations/campaignOperations/operations";
import { downloadCsv } from "../../../utils/downloadCsv";

interface DownloadCorrectionsButtonProps {
    urlSearch: string;
    dateRangeFilter: { label: string; value: string };
    categoryFilter: { label: string; value: string };
    startDateFilter: Date;
    endDateFilter: Date;
}

export const DownloadCorrectionsButton = ({
    urlSearch,
    dateRangeFilter,
    categoryFilter,
    startDateFilter,
    endDateFilter,
}: DownloadCorrectionsButtonProps) => {

    const hitlFilters = useHitlFilters();
    const [offset, setOffset] = useState(0);
    const [compiledData, ] = useState<ReviewedUrlTypeEdge[]>([]);
    const [isDownloading, setIsDownloading] = useState(false);

    const startDate = startDateFilter.toISOString().split("T")[0]
    const endDate = endDateFilter.toISOString().split("T")[0]

    const [getDownloadData, { data }] = useLazyQuery(
        GET_REVIEWED_URLS_LIST_PAGINATION_DOWNLOAD,
        {
          variables: {
            skip: !isDownloading,
            first: 100,
            offset: offset,
            publisher: hitlFilters.publisherFilter.value,
            dateRange: dateRangeFilter.value,
            filterStartDate: startDate,
            filterEndDate: endDate,
            search: urlSearch,
            category:
              categoryFilter.value === "ALL"
                ? ""
                : categoryFilter.value,
          },
          fetchPolicy: "cache-and-network",
          onCompleted: () => {
            if (
              data.reviewedUrlsListPaginated.totalCount !== 0 &&
              offset < data.reviewedUrlsListPaginated.totalCount
            ) {
              compiledData.push(...data.reviewedUrlsListPaginated.edges);
              setOffset(offset + 100);
              getDownloadData();
            } else {

              const dataFormatted: {
                url: string,
                accepted_classification: string,
                rejected_classification: string,
                original_classification: string,
                review_date: string,
                email: string,

              }[] = compiledData.map(({ node }: { node: ReviewedUrlType }) => {

                return ({
                  url: node.url,
                  accepted_classification: node.reviewedClassification ?? "",
                  rejected_classification: node.rejectedClassification ?? "",
                  original_classification: node.originalClassification ?? "",
                  review_date: node.createdAt ?? "",
                  email: node.reviewedBy.email
                })
              });

              const headers = [
                "url",
                "accepted_classification",
                "rejected_classification",
                "original_classification",
                "review_date",
                "email"
              ];
              const formattedDate = new Date().toLocaleDateString();
              const fileName = `illuma-${formattedDate}-${dateRangeFilter.label}-corrections`;
              
              // functionality only triggered when download button is clicked
              if (isDownloading) {
                downloadCsv(dataFormatted, headers, fileName);
              }
              
              setIsDownloading(false);
            }

          },
          onError: (error) => {
            console.error(error);
          }
        },
      );

    return (
        <Tooltip
            label={"Download corrections CSV"}
            openDelay={600}
            p={2}
        >
            <IconButton
                aria-label={"Download data"}
                variant={"whiteBoxButton"}
                icon={<Icon as={BsDownload} w={5} h={5} />}
                isLoading={isDownloading}
                onClick={() => {
                    setIsDownloading(true);
                    getDownloadData();
                }}
            />
        </Tooltip>
    )
}
